class ManualFiltering {
    constructor() {
        this.SECTION = ".manual-archive";
        this.MANUALS_TABLE = "[manuals-table]";
        this.MANUAL_ROW = "[manual-row]";
        this.ACTIVE_ROW = "[manual-row].active";
        this.MANUAL_TITLE = "data-manual-title";
        this.MANUAL_CATEGORY = "data-manual-category";
        this.MANUAL_MODEL = "data-manual-model";
        this.CATEGORY_SELECT = "select-category";
        this.MODEL_INPUT = "model-input";
        this.NO_RESULTS = "[no-results]";
        this.LOAD_MORE_BTN = "[load-more-btn]";
        this.LOAD_AMOUNT = "data-load-amount";

        this.init();
    }

    init() {
        this.initLoadMore();
        document.body.addEventListener('change', this.handleChange.bind(this));
        document.body.addEventListener('input', this.handleInput.bind(this));
    }

    handleChange(e) {
        this.getSelectValue(e);
    }

    handleInput(e) {
        this.getInputChange(e);
    }

    // Event handlers
    getSelectValue(e) {
        if (e.target.id !== this.CATEGORY_SELECT) return;
        let select_value = e.target.value;
        let filter_target = e.target.name;
        if (select_value === "all") {
            this.showAllManuals();
            return;
        }
        this.getFilterManuals(select_value,filter_target);
    }

    getInputChange(e) {
        if (e.target.id !== this.MODEL_INPUT) return;
        let input_value = e.target.value;
        let filter_target = e.target.name;
        if (input_value.length > 3) {
            this.getFilterManuals(input_value,filter_target);
        } else if (input_value.length === 0) {
            this.showAllManuals();
        }
    }

    // Setup Fuse.js
    setOptions(type) {
        let options = {
            includeScore: true,
            threshold: 0,
            keys: [type],
        };
        return options;
    }

    // Get data
    getManualsData() {
        let manuals = [];
        let manuals_data = document.querySelectorAll(this.MANUAL_ROW);
    
        manuals_data.forEach((manual) => {
            let manual_title = manual.getAttribute(this.MANUAL_TITLE);
            let manual_category = manual.getAttribute(this.MANUAL_CATEGORY);
            let manual_model = manual.getAttribute(this.MANUAL_MODEL);
    
            manuals.push({
                title: manual_title,
                category: manual_category,
                model: manual_model,
            });
        });
        return manuals;
    }

    // Get elements
    getManualsElements() {
        const manuals = document.querySelectorAll(this.MANUAL_ROW);
        return manuals;
    }

    // Filter data
    getFilterManuals(category,type) {
        const fuse = new window.fuse(this.getManualsData(), this.setOptions(type));
        const filtered = fuse.search(category);
        const filtered_ids = filtered.map((item) => item.refIndex);
        this.displayFilteredManuals(filtered_ids);
    }

    // Manipulate DOM
    displayFilteredManuals(filtered_ids) {
        let manuals = this.getManualsElements();
        manuals.forEach((manual) => {
            let el_id = manual.getAttribute("id");
            let isExactlyPresent = filtered_ids.some((el) => el === +el_id);

            if (isExactlyPresent) {
                manual.classList.add("active");
                manual.classList.remove("hidden");
            } else {
                manual.classList.remove("active");
                manual.classList.add("hidden");
            }
        });
        this.checkIfManualsPresent();
        document.querySelector(this.LOAD_MORE_BTN).classList.add("hidden");
    }

    showAllManuals() {
        let manuals = this.getManualsElements();
        let i = 0;
        manuals.forEach((manual) => {
            manual.classList.remove("active");
            manual.classList.remove("hidden");
            i++;
        });
        document.querySelector(this.NO_RESULTS).classList.add("hidden");
        document.querySelector(this.MANUALS_TABLE).classList.remove("hidden");
        document.querySelector(this.LOAD_MORE_BTN).classList.remove("hidden");
    }

    checkIfManualsPresent() {
        const hidden_manuals = document.querySelectorAll(this.ACTIVE_ROW);
        if (hidden_manuals.length === 0) {
            document.querySelector(this.NO_RESULTS).classList.remove("hidden");
            document.querySelector(this.MANUALS_TABLE).classList.add("hidden");
            document.querySelector(this.LOAD_MORE_BTN).classList.add("hidden");
        } else {
            document.querySelector(this.NO_RESULTS).classList.add("hidden");
            document.querySelector(this.MANUALS_TABLE).classList.remove("hidden");
        }
    }

    // Load more
    initLoadMore() {
        const load_amount = parseInt(document.querySelector(this.LOAD_MORE_BTN).getAttribute(this.LOAD_AMOUNT));
        const load_more = new window.LoadMore({
            target: this.MANUAL_ROW, 
            container: this.SECTION, 
            loadBtn: this.LOAD_MORE_BTN,
            initLoadAmount: load_amount,
            loadProgressAmount: load_amount
        });
    }

}

const manualFiltering = new ManualFiltering();